export default __webpack_public_path__ + "static/media/wai.90902c44.svg";